import { DateTime } from "luxon"
import { Tooltip } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers"
import { useAppLocalization } from "../../../../../../../../modules/localization/components/AppLocalizationProvider"
import { useDateTime } from "../../../../../../../../modules/localization/useDateTime"
import { validateDeliveryDate } from "../../helpers"

const useStyles = makeStyles()((theme) => ({
    box: {
        background: theme.palette.tailwind.red[300],
        color: theme.palette.common.white,
        "&.Mui-disabled:not(.Mui-selected)": {
            color: theme.palette.common.white,
        },
    },
    smallRoot: {
        width: "1.75rem",
        height: "1.75rem",
        margin: ".25rem .375rem",
    },
}))
type CustomDayProps = PickersDayProps<unknown> & {
    closingDates: string[]
    allowedWeekdays: number[]
}

export function CustomDay(props: CustomDayProps) {
    const { day, closingDates, allowedWeekdays, ...other } = props
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()
    const dateTimeFactory = useDateTime()

    const dayDateTime = day instanceof DateTime ? day : dateTimeFactory.fromJSDate(day as Date)
    const today = dateTimeFactory.now().startOf("day")

    const { isValidDeliveryDate } = validateDeliveryDate(dayDateTime, allowedWeekdays, closingDates)

    const isPast = dayDateTime < today
    const isUnavailable = !isValidDeliveryDate
    const isDisabled = isUnavailable || isPast

    return (
        <Tooltip
            title={
                isUnavailable ? l10n.getString("create-order-delivery-times-dialog-delivery-date-close-tooltip") : ""
            }
            arrow
        >
            <span>
                <PickersDay
                    {...other}
                    day={day}
                    disabled={isDisabled}
                    className={isUnavailable ? classes.box : undefined}
                    classes={{ root: classes.smallRoot }}
                />
            </span>
        </Tooltip>
    )
}
